export default {"src":"/_next/static/media/carbon_delivery-parcel.5a051029.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};